import React from 'react';
import {connect} from 'react-redux';

import {Dispatch} from 'spectra-logic-ui';
import {FormDialog} from 'spectra-logic-ui/components';
import {createResource} from 'spectra-logic-ui/actions';

import {Typography} from '@mui/material';

type Props = {
  id: string;
  description: string;
  onSubmit: (values: any) => Promise<any>;
}

const ConsolidateStorageDialog = (props: Props) => {
  const {description, onSubmit, ...others} = props;

  return (
    <FormDialog title='Consolidate Storage' submitLabel='Consolidate' onSubmit={onSubmit} {...others}>
      {() => (
        <Typography>{description}</Typography>
      )}
    </FormDialog>
  );
};

const mapDispatchToProps = (dispatch: Dispatch, {id}: Props) => {
  const resource = `storage/${id}/consolidate`;
  return {
    onSubmit: () => dispatch(createResource(resource)),
  };
};

export default connect(undefined, mapDispatchToProps)(ConsolidateStorageDialog);
